import React, {useContext, useEffect, useState} from "react";
import { Container, Draggable } from "react-smooth-dnd";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import DeleteIcon from '@material-ui/icons/Delete';
import {GalleryModal} from "../../contents/gallery";
import {FileInfo} from "../../../../interface/model/file";
import Api from '../../../../interface/api/content/education';
import {HostStateContext} from "../../../admin/index";
import {SiteVisitPurposeGroupInfo} from "../../../../interface/model/site";
import SiteVisitPurposeGroupInfoApi from "../../../../interface/api/site";

export default function EducationDetail({selectedEducation, modeHandler}) {
    const { hostInfo } = useContext(HostStateContext);
    const [ modal, setModal ] = useState(false);
    const [ items, setItems ] = useState<Array<FileInfo>>([]);
    const [ educationInfo, setEducationInfo ] = useState<any>({});
    const [ siteVisitPurposeGroupInfos, setSiteVisitPurposeGroupInfos ] = useState<Array<SiteVisitPurposeGroupInfo>>([]);
    const [ selectedSiteVisitPurposeInfos, setSelectedSiteVisitPurposeInfos ] = useState<Array<SiteVisitPurposeGroupInfo>>([]);

    function selectedHandler(data, e) {
        if(e.target.checked)
            setSelectedSiteVisitPurposeInfos(selectedSiteVisitPurposeInfos.concat(data))
        else
            setSelectedSiteVisitPurposeInfos(selectedSiteVisitPurposeInfos.filter(row => row.seq!==data.seq));

    }

    const onDrop = ({ removedIndex, addedIndex }) => {
        let item = items.splice(removedIndex, 1);
        items.splice(addedIndex, 0, item[0]);
        setItems([...items]);
    };

    function modalHandler() {
        setModal(!modal);
    }

    function importMediaHandler(selectedFileInfos) {
        setItems(selectedFileInfos);
    }

    function removeContentsHandler(fileInfoSeq) {
        setItems(items.filter(row => row.seq != fileInfoSeq));
    }

    function submit() {
        Api.createEducationInfo({
            seq : educationInfo.seq,
            siteInfoSeq : hostInfo.siteInfo.seq,
            name : educationInfo.name,
            expiryDate : educationInfo.expiryDate,
            timer : educationInfo.timer,
            fileInfos : items,
            siteVisitPurposeGroupInfos : selectedSiteVisitPurposeInfos
        }).then(res => alert('정상적으로 저장되었습니다.'));
    }

    useEffect(() => {
        if(selectedEducation!=null) {
            setEducationInfo({...selectedEducation, seq : selectedEducation.seq});
            setItems(selectedEducation.educationInfos.map(row => row.fileInfo));
        }
        SiteVisitPurposeGroupInfoApi.getSiteVisitPurposeGroupInfo(hostInfo.siteInfo.seq).then(res => {
            setSiteVisitPurposeGroupInfos(res.data);
        });
    }, [])

    return (
        <div className="nv_contents">
            <div className="nv_table_tit nv_wirte_tit">
                <h4>교육 관리</h4>
                <p><span className="nv_red">*</span> 는 필수 입력 사항입니다.</p>
            </div>
            <table className="nv_table nv_write_table">
                <colgroup>
                    <col width={'20%'}/>
                    <col/>
                </colgroup>
                <tbody>
                <tr>
                    <td className="nv_bold textcenter"><span className="nv_red">*</span>교육명</td>
                    <td>
                        <input type="text"
                               className="nv_input"
                               name="title"
                               placeholder="교육명을 입력해주세요."
                               value={educationInfo.name}
                               onChange={(e) => setEducationInfo({...educationInfo, name : e.target.value})}
                        />
                    </td>
                </tr>
                <tr>
                    <td className="nv_bold textcenter"><span className="nv_red">*</span>유효개월설정</td>
                    <td>
                        <input type="number"
                               className="nv_input"
                               name="title"
                               placeholder="개월"
                               value={educationInfo.expiryDate}
                               onChange={(e) => setEducationInfo({...educationInfo, expiryDate : e.target.value})}
                        />
                    </td>
                </tr>
                <tr>
                    <td className="nv_bold textcenter"><span className="nv_red">*</span>타이머설정</td>
                    <td>
                        <input type="number"
                               className="nv_input"
                               name="title"
                               placeholder="초"
                               value={educationInfo.timer}
                               onChange={(e) => setEducationInfo({...educationInfo, timer : e.target.value})}
                        />
                    </td>
                </tr>
                <tr>
                    <td className="nv_bold textcenter"><span className="nv_red">*</span>방문 목적 그룹</td>
                    <td className="nv_gray_check">
                            <ul>
                                {
                                    siteVisitPurposeGroupInfos.map((row, index) =>
                                        <li key={`groupcheckboxIndex${index}`} style={{width:'45%'}}>
                                            <input type="checkbox"
                                                   id={`checkbox-${index}`}
                                                   value={row.seq}
                                                // checked={selectedSecretaryHostInfo!==undefined && selectedSecretaryHostInfo.number == row.number}
                                                   onClick={(e) => (selectedHandler(row, e))}
                                            />
                                            <label htmlFor={`checkbox-${index}`}>{row.name}</label>
                                            {row.name}
                                        </li>
                                    )
                                }
                            </ul>
                    </td>
                </tr>
                <tr>
                    <td className="nv_bold textcenter"><span className="nv_red">*</span>
                        미디어 설정
                    </td>
                    <td>
                        <button type="submit" className="nv_blue_button m_w_100" style={{float:'none'}} onClick={modalHandler}>미디어 불러오기</button>
                        <List>
                            <Container dragHandleSelector=".drag-handle" lockAxis="y" onDrop={onDrop}>
                                {items.map((row, index) => (
                                    <Draggable key={row.seq}>
                                        <ListItem>
                                            <ListItemIcon className="drag-handle">
                                                <DragHandleIcon />
                                            </ListItemIcon>
                                            <ListItemText primary={row.fileName} />
                                            <ListItemSecondaryAction>
                                                <DeleteIcon onClick={() => removeContentsHandler(row.seq)}/>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    </Draggable>
                                ))}
                            </Container>
                        </List>
                    </td>
                </tr>
                </tbody>
            </table>
            <div className="btn_area nv_page_bottomarea_type2">
                <button type="button" className="nv_green_button m_w_100" onClick={() => modeHandler(null)}>취소</button>
                <button type="submit" className="nv_blue_button m_w_100" onClick={submit}>저장</button>
            </div>
            {
                modal && <GalleryModal closeModalHandler={modalHandler}
                              submitHandler={importMediaHandler}/>
            }
        </div>
    )
}